import { put, takeLatest } from "redux-saga/effects";
import {
  fetchUserConnectionsFailure,
  fetchUserConnectionsRequest,
  fetchUserConnectionsSuccess,
  revokeUserConnectionFailure,
  revokeUserConnectionRequest,
  revokeUserConnectionSuccess
} from "../features/userConnectionsSlice";
import { getUserConnections, revokeUserConnection } from "../../services/oauthClients";

function* fetchUserConnections(action: ReturnType<typeof fetchUserConnectionsRequest>) {
  try {
    const data = yield getUserConnections(action.payload);
    if (data?.ErrorCode) {
      throw new Error(data.Description || data.Message || data.ErrorMessage);
    }
    yield put(fetchUserConnectionsSuccess(data.Data || []));
  } catch (error: any) {
    yield put(fetchUserConnectionsFailure(error.message));
  }
}

function* revokeConnection(action: ReturnType<typeof revokeUserConnectionRequest>) {
  const { uid, clientId, parentClientId, successMessage } = action.payload;
  try {
    const data = yield revokeUserConnection(uid, clientId, parentClientId);
    if (data?.ErrorCode) {
      throw new Error(data.Description || data.Message || data.ErrorMessage);
    }
    yield put(revokeUserConnectionSuccess({ clientId, parentClientId, message: successMessage }));
  } catch (error: any) {
    yield put(revokeUserConnectionFailure(error.message));
  }
}

export function* watchUserConnectionsSaga() {
  yield takeLatest(fetchUserConnectionsRequest.type, fetchUserConnections);
  yield takeLatest(revokeUserConnectionRequest.type, revokeConnection);
}
